import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import LoadingScreen from '../components/LoadingScreen';

// ----------------------------------------------------------------------

type AuthProtectProps = {
  children: ReactNode;
};

export default function AuthProtect({ children }: AuthProtectProps) {
  const { isLoading, isAuthenticated, user } = useAuth(); // fixing bug that related to wrong redirect to Home page
  const token = new URLSearchParams(useLocation().search).get('token');
  const accessToken = localStorage.getItem('accessToken');

  if (token) {
    localStorage.setItem('newToken', token);
  } else {
    localStorage.removeItem('newToken');
  }

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!token && !isAuthenticated && !user?.id && !isLoading && !accessToken) {
    return <Navigate to="/auth/login" />;
  }

  if (!isAuthenticated && user?.id) {
    localStorage.removeItem('newToken');
    return <Navigate to="/auth/login" />;
  }

  return <>{children}</>;
}
